import { render } from "./TransfertEleve.vue?vue&type=template&id=4e2ad9ea&scoped=true"
import script from "./TransfertEleve.vue?vue&type=script&lang=js"
export * from "./TransfertEleve.vue?vue&type=script&lang=js"

import "./TransfertEleve.vue?vue&type=style&index=0&id=4e2ad9ea&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e2ad9ea"]])

export default __exports__